<template>
    <div class="container-fluid">
        <div class="container ">

            <div class="row">

                <div class=" col " style="min-width:400px">
                    <h1 class="text-center fs-24 my-5 text-semibold">Optical Zoom Field of View Calculator</h1>

                    <div class="input-group">
                        <input min="0" max="100000" v-model="distance" autofocus type="number"
                               class="form-control  tooltip-content" :placeholder="lengthPH"
                               @input="calculateZoom" @keyup=""
                               aria-label="Calculate" aria-describedby="Calculate">
                        <div class="input-group-append px-1">
                            <div class="custom-control custom-switch cal-switch">
                                <input @click="toggleTheSwitch" v-model="switchToggle" type="checkbox"
                                       class="custom-control-input" id="customSwitch1">
                                <label class="custom-control-label" for="customSwitch1" v-text="switchText"
                                ></label>
                            </div>
                        </div>
                    </div>
                    <span> <small>Note: *Distance in {{ unitLength }}. Image ratio 16:9.</small></span>
                </div>
                <table class=" mt-3 table table-striped table-bordered">
                    <thead>
                    <tr>
                        <th scope="col"></th>
                        <th scope="col">12x</th>
                        <th scope="col">20x</th>
                        <th scope="col">30x</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <th scope="row">Width Zoomed In</th>
                        <td v-text="zIn12"></td>
                        <td v-text="zIn20"></td>
                        <td v-text="zIn30"></td>
                    </tr>
                    <tr>
                        <th scope="row">Width Zoomed Out</th>
                        <td v-text="zOut12"></td>
                        <td v-text="zOut20"></td>
                        <td v-text="zOut30"></td>
                    </tr>

                    </tbody>
                </table>

            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "zoom-calc",
        data() {
            return {
                zIn12: '',
                zIn20: '',
                zIn30: '',
                zOut12: '',
                zOut20: '',
                zOut30: '',
                distance: '',
                switchToggle: false


            }
        },
        computed: {

            lengthPH() {
                return this.switchToggle ? 'Distance from camera lens (m)' : 'Distance from camera lens (ft)'
            },
            unitLength() {
                return this.switchToggle ? 'Meters' : 'Feet'
            },
            switchText() {
                return this.switchToggle ? 'Metric' : 'Standard'

            }
        },
        methods: {
            toggleTheSwitch() {

                this.switchToggle = !this.switchToggle

                    if (this.switchToggle === true) {
                        this.distance = this.distance / 3.28084;
                    } else {
                        this.distance = this.distance * 3.28084;
                    }
                    this.calculateZoom()


                /* this.zIn12=0
                     this.zIn20=0
                     this.zIn30=0
                     this.zOut12=0
                     this.zOut20=0
                     this.zOut30=0*/
            },
            calculateZoom() {
                if (this.switchToggle) {

                    this.trueDistance = this.distance * 3.28084;
                    if (this.trueDistance > 10000 || this.trueDistance < 0) {
                        this.trueDistance = null
                    }
                } else {
                    this.trueDistance = this.distance;
                    if (this.trueDistance > 3047 || this.trueDistance < 0) {
                        this.trueDistance = null
                    }
                }

                if (this.trueDistance) {
                    this.computeNow(this.trueDistance)
                }


            },
            computeNow(trueDistance) {
                this.zIn12 = (2 * (trueDistance * Math.tan(this.degrees_to_radians(7 / 2)))).toFixed(1);
                this.zIn20 = (2 * (trueDistance * Math.tan(this.degrees_to_radians(4 / 2)))).toFixed(1);
                this.zIn30 = (2 * (trueDistance * Math.tan(this.degrees_to_radians(2.28 / 2)))).toFixed(1);
                this.zOut12 = (2 * (trueDistance * Math.tan(this.degrees_to_radians(71 / 2)))).toFixed(1);
                this.zOut20 = (2 * (trueDistance * Math.tan(this.degrees_to_radians(60 / 2)))).toFixed(1);
                this.zOut30 = (2 * (trueDistance * Math.tan(this.degrees_to_radians(60 / 2)))).toFixed(1);
            },
            degrees_to_radians(degrees) {
                var pi = Math.PI;
                return degrees * (pi / 180);
            },
            limitInput() {

            }
        }
    }
</script>

<style scoped>
    .cal-switch .custom-control-label:after {
        background-color: #e91e63;
    }

    .cal-switch .custom-control-label:before {
        background-color: #3d1ce9;
    }
</style>
